import { ValidableField } from './ValidableField';
import { ChangeEvent } from 'react';
import { Checkbox } from '@apia/components';
import { makeValidableField } from './makeValidableField';

export const ValidableCheck = makeValidableField(
  ({ context, label, path, onChange, ...props }) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      context.setValue(path, event.target.value);
      onChange?.(event);
    };

    return (
      <ValidableField
        context={context}
        path={path as never}
        avoidSemicolon
        label={label}
        {...props}
        className={`checkbox ${props.className}`}
      >
        <Checkbox
          name={path}
          checked={context.getValue(path)}
          onChange={handleChange}
        />
      </ValidableField>
    );
  },
);
